export default {
  common: {
    nav: {
      home: "בית",
      find_offer_help: "מצא / הצע עזרה",
      celebrate: "לחגוג חיים",
      family_tree: "אילן יוחסין",
      events: "אירועים",
      civic_reports: "דיווחי אזרחים",
      neighborhood_pulse: "דופק השכונה",
      weather: "מזג אוויר",
      nature: "טבע",
      marketplace: "שוק",
      news: "חדשות",
      causes: "מטרות",
      more: "עוד",
    },
    header: { sign_in: "התחברות", join: "הצטרפו ל-Social Pulse", language: "שפה", search: "חיפוש" },
    tagline: "מחברים קהילות · מעצימים חיים · בונים הון חברתי",
    locality: { viewing_from: "אתם צופים מ", change: "שנה", set_your_location: "הגדירו את מיקומכם" },
    news: { title: "התדריך היומי שלכם.", play_briefing: "השמע תדריך יומי", listen: "האזינו", translate: "תרגם" },
  },
};
